<template>
  <div class="audio-main">
    <div
      v-for="(item, index) in list"
      :key="index"
      class="audio-content"
      @click="goDetail(item.uuid, 'type')"
    >
      <span class="title" v-html="item.title"></span>
      <span class="desc">{{ item.summary }}</span>
      <span class="time">{{ Number(item.create_time) | datetimeFormat }}</span>
      <div class="line"></div>
    </div>
    <van-dialog
      v-model="show"
      title=""
      className="audio-info"
      :showConfirmButton="false"
      closeOnClickOverlay
      :beforeClose="beforeCloseAudio"
    >
      <div>
        <div>
          <span class="title">{{ detail.title }}</span>
          <van-image
            width="20"
            height="3"
            class="line-img"
            :src="require('@/assets/line.png')"
          />
          <span class="desc">{{ detail.summary }}</span>
          <div>
            <mobile-audio-new
              ref="audioNew"
              :fileurl="detail.audio_url"
            ></mobile-audio-new>
            <!-- <audio controls class="audio-control">
              <source :src="require('@/assets/1.mp3')" />

              您的浏览器不支持音频播放
            </audio> -->
          </div>
        </div>
      </div>

      <!-- <van-image
        width="36"
        height="36"
        class="close-img"
        @click="closeDialog"
        :src="require('@/assets/close.png')"
      /> -->
    </van-dialog>
  </div>
</template>
<script>
import MobileAudioNew from "./MobileAudio.vue";
export default {
  components: {
    MobileAudioNew,
  },
  props: {
    list: {
      type: Array,
    },
  },
  data() {
    return {
      show: false,
      detail: {},
    };
  },
  methods: {
    goDetail(id) {
      this.getDetail(id);
      this.show = true;
    },
    async getDetail(id) {
      try {
        const { data } = await this.$axios.post(`Articleeducate/getDetail`, {
          id: id,
          type: 3,
        });
        this.detail = data;
      } catch (error) {
        this.$toast(error?.errorMSg ?? "暂无数据");
      } finally {
        this.loading = false;
      }
    },
    closeDialog() {
      this.$refs.audioNew.pauseAudio();
      this.show = false;
    },
    beforeCloseAudio() {
      this.$refs.audioNew.pauseAudio();
      this.show = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.audio-main {
  min-height: calc(100vh - 700px);
}

.audio-content {
  display: inline-block;
  width: 663px;
  height: auto;
  margin-top: 30px;
  margin-left: 43px;
  cursor: pointer;

  .title {
    display: -webkit-box; /* stylelint-disable-line */
    display: -ms-flexbox; /* stylelint-disable-line */
    width: 663px;
    height: 110px;
    margin-top: 27px;
    overflow: hidden;
    font-size: 36px;
    font-weight: 500;
    line-height: 55px;
    color: #333;
    text-overflow: ellipsis;
    word-break: break-all;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;

    ::v-deep span {
      color: rgb(0 71 255 / 100%);
    }
  }

  .desc {
    display: -webkit-box; /* stylelint-disable-line */
    display: -ms-flexbox; /* stylelint-disable-line */
    width: 663px;
    height: 66px;
    margin-top: 19px;
    overflow: hidden;
    font-size: 24px;
    font-weight: 400;
    line-height: 33px;
    color: #333;
    text-overflow: ellipsis;
    word-break: break-all;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .time {
    display: inline-block;
    margin-top: 20px;
    font-size: 24px;
    font-weight: bold;
    color: #666;
  }

  .line {
    width: 663px;
    height: 1px;
    margin-top: 29px;
    background: #ccc;
  }
}

.audio-info {
  width: 690px;
  overflow: inherit;
  background: white;
  border-radius: 0;

  .title {
    display: -webkit-box; /* stylelint-disable-line */
    display: -ms-flexbox; /* stylelint-disable-line */
    width: 617px;
    height: 150px;
    margin-top: 27px;
    margin-left: 40px;
    overflow: hidden;
    font-size: 30px;
    font-weight: 500;
    line-height: 50px;
    color: #333;
    text-overflow: ellipsis;
    word-break: break-all;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }

  .line-img {
    margin-top: 20px;
    margin-left: 40px;
  }

  .desc {
    display: -webkit-box; /* stylelint-disable-line */
    display: -ms-flexbox; /* stylelint-disable-line */
    width: 617px;
    height: 120px;
    margin-top: 19px;
    margin-left: 40px;
    overflow: hidden;
    font-size: 24px;
    font-weight: 400;
    line-height: 40px;
    color: #333;
    text-overflow: ellipsis;
    word-break: break-all;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }

  .audio-control {
    width: 100%;
    height: 30px;
  }

  .close-img {
    position: absolute;
    top: -2px;
    right: -36px;
    cursor: pointer;
  }
}
</style>
